// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Photos_wrapper__3OFfJ","text":"Photos_text__1EXfk","toDownload":"Photos_toDownload__1HMLV"};